BX.namespace("BX.Chili.Comments.Modal");

/**
 * @param {Object} options
 * @param {HTMLElement|Element} options.container
 * */
BX.Chili.Comments.Modal = function (options) {
    if (!new.target) {
        return new BX.Chili.Comments.Modal(options);
    }

    if (!options.container) {
        throw new Error("Container is not defined");
    }

    this.options = options;

    this.container = options.container;
    this.closeButton = this.container.querySelector(".js-chili-close");
    this.overlay = this.container;
    this.content = this.container.querySelector('.red-modality');

    this.open = function () {
        this.container.style.display = "block";
    }

    this.close = function () {
        this.container.style.display = "none";
    }

    if (this.closeButton) {
        this.closeButton.addEventListener("click", () => {
            this.close();
        });
    }

    this.overlay.addEventListener("click", () => {
        this.close();
    });

    this.content.addEventListener('click', (event) => {
        event.stopPropagation();
    });
}
